import { render } from "./PageJadwalWawancaraPsikologi.vue?vue&type=template&id=16364950"
import script from "./PageJadwalWawancaraPsikologi.vue?vue&type=script&lang=js"
export * from "./PageJadwalWawancaraPsikologi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__